import React from 'react';

const Footer = props => {
	return <footer>Made with &#10084; and &#60;&#47;&#62; by Aman Khandelwal</footer>;
};

export default Footer;



// WEBPACK FOOTER //
// ./src/footer.js